<div class="container-fluid container-box">
    <div  *ngIf="potentialError" [style]="{'height': messageflexHeight}">
      <div class="row">
        <div class=" ipadWrapper">
          <div *ngIf="!importError" class="d-flex justify-content-center  justify-content-md-start">
            <span  class="text-semi-primary no-error">No potential duplicates detected.</span>
        </div>
        <div *ngIf="importError" class="d-flex justify-content-center  justify-content-md-start">
          <span  class="text-semi-primary no-error">No errors detected.</span>
      </div>
      </div>
     </div>
    </div>
  <div *ngIf="!potentialError">
    <div class="my-1 mx-3">
      <p class="text-primary-color"> Potential Duplicates</p>
      <span class="font-11 text-gray">
        A record(s) you added looks like a duplicate. Do you want to proceed with adding this record(s)?</span>
    </div>
  <ng-container *ngIf="data?.duplicateData?.rowData?.length !== 0">
    <div class="overflow-auto" [style]="{'height': flexHeight}">
      <div class="" *ngFor="let item of data?.duplicateData?.rowData;let i=index">
        <div class="my-2 mx-3 text-semi-primary font-13">
          Duplicate {{i+1}}
        </div>
         <app-ag-grid 
           class="center-Pagination d-block position-relative minHeightSet"
           [ngStyle]="{'height': flexHeight}" 
           [dataModel]="dataModel" 
           [paginations]="false"
           [columnSettings]="false"
           (gridReady)="onGridReady($event)">
    </app-ag-grid>
        <app-custom-loader *ngIf="!importError" class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isLoading"></app-custom-loader>
      </div>
    </div>
  </ng-container>
    <div *ngIf="data?.duplicateData?.rowData?.length === 0" class="text-center position-absolute top-50 start-50">
      No Records Available
          </div>
        </div>
  </div>